module.exports = __webpack_public_path__ + "static/media/gcdef_10028.051db03e.ico";